import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ImageComponent } from '@libs/common/components';
import { BannerItemModel, GalleryImageItemModel, ImageLinkItemModel, ImageSliderItemModel } from '@libs/cms/models';
import { PageBlockImpressionDirective, PageBlockLinkClickDirective, provideContentTrackingData } from '@libs/shared/tracking';
import { ContentLinkDirective } from '@libs/shared/ui';

type ImageSlideItemModel = ImageLinkItemModel | BannerItemModel | ImageSliderItemModel | GalleryImageItemModel;

@Component({
  selector: 'ui-image-slide',
  templateUrl: './image-slide.component.html',
  styleUrls: ['./image-slide.component.scss'],
  imports: [
    ImageComponent,
    ContentLinkDirective,
    PageBlockLinkClickDirective,
    NgTemplateOutlet,
  ],
  host: {
    '[class.responsive]': 'hasResponsiveImage()',
    '[class.gallery-image]': "data().type === 'galleryImage'",
  },
  providers: [
    provideContentTrackingData(ImageSlideComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [PageBlockImpressionDirective],
})
export class ImageSlideComponent {
  public readonly data: InputSignal<ImageSlideItemModel> = input.required();

  public readonly hasResponsiveImage: Signal<boolean> = computed(() => {
    const img: ImageLinkItemModel['image'] = this.data().image;

    return (img.type === 'image' || img.type === 'animation') && img.source.length > 1;
  });
}
